import { ArrowUpDown } from "lucide-react";
import { useTranslation } from "react-i18next";

interface SortButtonProps {
  handleClick: () => void;
  title: string; // Pass a i18n translation key
}

export const SortButton = ({ handleClick, title }: SortButtonProps) => {
  const { t } = useTranslation();

  return (
    <button
      className="flex gap-2 items-center cursor-pointer hover:text-neutral-700"
      onClick={handleClick}
    >
      {t(`${title}`)}
      <ArrowUpDown size={24} className="h-4 w-4" />
    </button>
  );
};
